export function isAuctionItem(item = {}) {
  return (
    Number(item?.is_auction ?? item?.isAuction ?? item?.auction ?? 0) === 1 ||
    item?.is_auction === true ||
    item?.isAuction === true ||
    item?.auction === true
  );
}

export function isApprovedAuctionOffer(item = {}) {
  return isAuctionItem(item) && Number(item?.offer_status ?? item?.status ?? 0) === 2;
}
